import React,{useContext} from "react";
import themeContext from "../../../context/theme/ThemeContext";

const StackScrollCustom = () => {
  const {themeName} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15.3182 8.37753C15.1829 8.59403 15.0036 8.77971 14.792 8.92255L9.27537 12.6463C8.50467 13.1665 7.49526 13.1665 6.72457 12.6463L1.20791 8.92255C0.513995 8.45415 0.244905 7.5919 0.49745 6.83473L6.73545 10.9924C7.45332 11.471 8.37496 11.5009 9.11831 11.0822L9.26449 10.9924L15.5019 6.83427C15.6676 7.33229 15.6181 7.89768 15.3182 8.37753ZM15.5019 9.79782C15.6676 10.2958 15.6181 10.8612 15.3182 11.3411C15.1829 11.5576 15.0036 11.7433 14.792 11.8861L9.27537 15.6098C8.50467 16.1301 7.49526 16.1301 6.72457 15.6098L1.20791 11.8861C0.513995 11.4177 0.244905 10.5554 0.49745 9.79828L6.73545 13.956C7.45332 14.4346 8.37496 14.4645 9.11831 14.0457L9.26449 13.956L15.5019 9.79782ZM9.26449 0.382867L15.0686 4.2523C15.4877 4.53165 15.6009 5.09779 15.3215 5.51682C15.2548 5.61699 15.1688 5.70294 15.0686 5.76972L9.26449 9.63916C8.49876 10.1496 7.50118 10.1496 6.73545 9.63916L0.931298 5.76972C0.512272 5.49037 0.399043 4.92423 0.678394 4.5052C0.745174 4.40503 0.831128 4.31908 0.931298 4.2523L6.73545 0.382867C7.50118 -0.127622 8.49876 -0.127622 9.26449 0.382867ZM7.59944 1.46043L7.49416 1.52094L2.25981 5.01101L7.49416 8.50109C7.76642 8.68259 8.11195 8.70276 8.4005 8.56159L8.50578 8.50109L13.7392 5.01101L8.50578 1.52094C8.23351 1.33943 7.88798 1.31926 7.59944 1.46043Z"
        fill={themeName!="light"?"white":"black"}
      />
    </svg>
  );
};

export default StackScrollCustom;
